<template>
	<div>
		<alert v-if="jobLocation.lat == 0 && jobLocation.lng == 0" classes="alert-danger" message="Location not found" :unclosable="true" icon="fa-exclamation" :visible="true" class="mb-0" style="border-bottom-left-radius: 0;border-bottom-right-radius: 0;">
		</alert>

		<vue-map
			:zoom="mapZoom"
			:center="mapCenter"
			map-size="map-sm"
			:markers="markers"
			:circles="circles">	
		</vue-map>

		<div v-if="!hideDirections" class="text-center" style="margin-top: 5px;margin-bottom: 5px;"><a target="_blank" :href="'https://www.google.com/maps/dir/?api=1'+origin+'&destination='+jobLocation.lat+'+'+jobLocation.lng">Directions to Job</a></div>
	</div>
</template>
<script type="text/javascript">

import VueMap from "./VueMap"
import Alert from "@/components/Alert"

export default {
	name: "JobMap",
	components: {
		VueMap,
		Alert
	},
	props: ["currentPosition","jobLocation","mapZoom","checkInTolerance","hideDirections", "equipmentLocationMarkers"],
	computed: {
		mapCenter() {
			if (this.jobLocation && !isNaN(this.jobLocation.lat) && !isNaN(this.jobLocation.lng))
				return this.jobLocation
			else if (this.currentPosition && !isNaN(this.currentPosition.lat) && !isNaN(this.currentPosition.lng))
				return this.currentPosition
			else  {
				return {
					lat: 0,
					lng: 0
				}
			}
		},
		circles() {
			let circles = []

			if (this.jobLocation && !isNaN(this.jobLocation.lat) && !isNaN(this.jobLocation.lng)) {
				circles.push({
					lat: this.jobLocation.lat,
					lng: this.jobLocation.lng,
					radius: this.checkInTolerance,
					strokeColor: '#ffc107',
					fillColor: '#ffc1074f'
				})
			}
			if (this.currentPosition && !isNaN(this.currentPosition.lat) && !isNaN(this.currentPosition.lng)) {
				circles.push({
					lat: this.currentPosition.lat,
					lng: this.currentPosition.lng,
					radius: this.currentPosition.accuracy,
					strokeColor: '#07adff',
					fillColor: '#07adff3b'
				})
			}

			return circles
		},
		markers() {
			let markers = []

			if (this.jobLocation && !isNaN(this.jobLocation.lat) && !isNaN(this.jobLocation.lng)) {
				let marker = {
					lat: this.jobLocation.lat,
					lng: this.jobLocation.lng,
					icon: window.apiRoot+"resources/icons/hardhat_36_point.png",
				}

				if ("infoWindowText" in this.jobLocation)
					marker.infoWindowText = this.jobLocation.infoWindowText

				markers.push(marker)
			}
			if (this.currentPosition && !isNaN(this.currentPosition.lat) && !isNaN(this.currentPosition.lng)) {
				let marker = {
					lat: this.currentPosition.lat,
					lng: this.currentPosition.lng,
					icon: {
						anchor: {x: 18,y :18},
						url: window.apiRoot+"resources/icons/location_36.png",
					}
				}

				if ("infoWindowText" in this.currentPosition)
					marker.infoWindowText = this.currentPosition.infoWindowText

				markers.push(marker)
			}

			console.log(this.equipmentLocationMarkers)
			if (this.equipmentLocationMarkers) {

				this.equipmentLocationMarkers.forEach(eq => {
					markers.push({
						lat: eq.lat,
						lng: eq.lng,
						icon: {
							anchor: {x: 18,y :18},
							url: window.apiRoot+"resources/icons/truck_36.png",
						},
						infoWindowText: eq.infoWindowText
					})
				})
			}

			return markers
		},
		origin() {
			if (this.currentPosition)
				return "&origin="+this.currentPosition.lat+","+this.currentPosition.lng
			else
				return ""
		}
	}
}
	
</script>